module.exports = __webpack_public_path__ + "img/andresbogetto.c6dcc968.png";